/**
 * Analytics Event Names
 * These are the custom events we track in Heap
 */
export const AnalyticsEventNames = {
  // Authentication events
  USER_LOGIN: 'user_login',

  // Task events
  TASK_CREATED: 'task_created',
  TASK_DELETED: 'task_deleted',
  TASK_STATUS_CHANGED: 'task_status_changed',
  TASK_COMMENTED: 'task_commented',
  TASK_EDITED: 'task_edited',
  TASK_VIEWED: 'task_viewed',
  TASK_FEEDBACK_SUBMITTED: 'task_feedback_submitted',

  // User management events
  NEW_USER_CREATED: 'new_user_created',

  // Page view events (if needed beyond autocapture)
  PAGE_NAVIGATION: 'page_navigation',

  // Integration events
  INTEGRATION_ADDED: 'integration_added',
  INTEGRATION_CONNECTED: 'integration_connected',
  INTEGRATION_DISCONNECTED: 'integration_disconnected',
  FIRST_INTEGRATION_ADDED: 'first_integration_added',
  FIRST_INTEGRATION_CONNECTED: 'first_integration_connected',

  // Navigation events
  RETURNED_TO_DASHBOARD: 'returned_to_dashboard',

  // Engagement events
  SESSION_STARTED: 'session_started',
  SESSION_ENDED: 'session_ended',
};

/**
 * Analytics Property Names
 * These are the property keys we use for events and user properties
 */
export const AnalyticsPropertyNames = {
  // User properties
  USER_ID: 'userId',
  USER_EMAIL: 'email',
  USER_NAME: 'name',
  USER_ROLE: 'role',

  // Merchant properties
  MERCHANT_ID: 'merchantId',
  MERCHANT_NAME: 'merchantName',
  BLID: 'blid',

  // SKU and Integration properties
  HAS_SKU: 'hasSKU',
  HAS_INTEGRATION: 'hasIntegration',
  HAS_ACTIVE_INTEGRATION: 'hasActiveIntegration',
  INTEGRATION_COUNT: 'integrationCount',
  ACTIVE_INTEGRATION_COUNT: 'activeIntegrationCount',

  // Activation and Engagement properties
  IS_ACTIVATED: 'isActivated',
  IS_ENGAGED: 'isEngaged',
  HAS_ENHANCED_ENGAGEMENT: 'hasEnhancedEngagement',

  // Task properties
  TASK_ID: 'taskId',
  TASK_STATUS: 'taskStatus',
  TASK_ACTION: 'taskAction',
  TASK_TITLE: 'taskTitle',
  TASK_PRIORITY: 'taskPriority',

  // Page properties
  PAGE_NAME: 'pageName',
  PAGE_URL: 'pageUrl',
  PAGE_PATH: 'pagePath',

  // Action properties
  ACTION_TYPE: 'actionType',
  ACTION_TARGET: 'actionTarget',

  // Session properties
  SESSION_DURATION: 'sessionDuration',
  SESSION_ID: 'sessionId',
};

/**
 * Task Status values
 * These match the backend API status values (with hyphens)
 */
export const TaskStatus = {
  TODO: 'todo',
  IN_PROGRESS: 'in-progress',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};

/**
 * Task Action types
 */
export const TaskAction = {
  CREATE: 'create',
  EDIT: 'edit',
  DELETE: 'delete',
  COMMENT: 'comment',
  STATUS_CHANGE: 'status_change',
};
